module.exports = __webpack_public_path__ + "img/blue_156.8732baa0.png";